// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ********* CSS & Images ******************** //

import "./faqs.css";

// ************ Add Top Nav & Footer ***************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// ************ Add Email Signup Form *************** //

import '/src/nav-header-footer/email-signup-form.js';

// ********* JS - FAQs ******************** //

var question = document.getElementsByClassName("question");
var plus = document.getElementsByClassName("plus");

var plus1 = document.getElementById("plus-1");
plus1.setAttribute('data-after', '+');

var plus2 = document.getElementById("plus-2");
plus2.setAttribute('data-after', '+');

var plus3 = document.getElementById("plus-3");
plus3.setAttribute('data-after', '+');

var plus4 = document.getElementById("plus-4");
plus4.setAttribute('data-after', '+');

var plus5 = document.getElementById("plus-5");
plus5.setAttribute('data-after', '+');

var i;

const unicodeMinus = "\u2212";
const escapedMinus = CSS.escape(unicodeMinus);


for (let i = 0; i < question.length; i++) {

	question[i].addEventListener("click", function() {

		// console.log(question[i].id);

		this.classList.toggle("active");

		var answer = this.nextElementSibling;

		if (answer.style.maxHeight) {

			answer.style.maxHeight = null;
			

			if (question[i].id == "question-1") {

				plus1.setAttribute('data-after', '+');
			}

			if (question[i].id == "question-2") {

				plus2.setAttribute('data-after', '+');
			}

			if (question[i].id == "question-3") {

				plus3.setAttribute('data-after', '+');
			}

			if (question[i].id == "question-4") {

				plus4.setAttribute('data-after', '+');
			}

			if (question[i].id == "question-5") {

				plus5.setAttribute('data-after', '+');
			}

			if (question[i].id == "question-6") {

				plus6.setAttribute('data-after', '+');
			}

		} else {


			if (question[i].id == "question-1") {

				plus1.setAttribute('data-after', `${escapedMinus}`);
			}

			if (question[i].id == "question-2") {

				plus2.setAttribute('data-after', `${escapedMinus}`);
			}

			if (question[i].id == "question-3") {

				plus3.setAttribute('data-after', `${escapedMinus}`);
			}

			if (question[i].id == "question-4") {

				plus4.setAttribute('data-after', `${escapedMinus}`);
			}

			if (question[i].id == "question-5") {

				plus5.setAttribute('data-after', `${escapedMinus}`);
			}

			if (question[i].id == "question-6") {

				plus6.setAttribute('data-after', `${escapedMinus}`);
			}

			answer.style.maxHeight = answer.scrollHeight + "px";
		} 
	});
}